export default __webpack_public_path__ + "static/media/ChatApp.5b7b2eae.png";